import trackingVersionMapping from "../constants/TrackingVersionMapping";

export const teal200 = "oklch(91% 0.096 180.426)";
export const teal300 = "oklch(85.5% 0.138 181.071)";
export const teal400 = "oklch(77.7% 0.152 181.912)";

export const orange200 = "oklch(90.1% 0.076 70.697)";
export const orange300 = "oklch(83.7% 0.128 66.29)";
export const orange400 = "oklch(75% 0.183 55.934)";

// New Iris palette for TrackMan club-owned games
export const iris200 = "oklch(88% 0.07 285)";
export const iris300 = "oklch(80% 0.12 285)";
export const iris400 = "oklch(70% 0.16 285)";

export const getBackgroundColor = (game) => {
  if (isTrackmanOwned(game)) {
    return iris200;
  }

  if (isClubOwned(game)) {
    return orange200;
  }

  if (isHybrid(game)) {
    return teal200;
  }

  return "";
};

const isTrackmanOwned = (game) => {
  return (
    trackingVersionMapping.trackmanOwnedSystemVersion.includes(
      game?.trackingVersion?.id,
    ) &&
    trackingVersionMapping.trackmanOwnedSystemOwner.includes(
      game?.trackingVersion?.owner?.id,
    )
  );
};

const isClubOwned = (game) => {
  return (
    trackingVersionMapping.clubOwnedSystemVersion.includes(
      game?.trackingVersion?.id,
    ) &&
    trackingVersionMapping.clubOwnedSystemOwner.includes(
      game?.trackingVersion?.owner?.id,
    )
  );
};

const isHybrid = (game) => {
  return (
    trackingVersionMapping.hybridOwnedSystemVersion.includes(
      game?.trackingVersion?.id,
    ) &&
    trackingVersionMapping.hybridOwnedSystemOwner.includes(
      game?.trackingVersion?.owner?.id,
    )
  );
};
